var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 300,
    viewBox: "0 0 137 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59449 295.502C1.49115 295.45 0.554418 296.302 0.502233 297.406C0.450048 298.509 1.30217 299.446 2.40551 299.498L2.59449 295.502ZM125 0L113.038 19.7547L136.127 20.2366L125 0ZM2.40551 299.498C20.763 300.366 37.48 296.465 52.2728 286.68C67.0444 276.908 79.7466 261.369 90.2725 239.211C111.293 194.958 123.83 123.882 126.624 18.0566L122.625 17.951C119.834 123.656 107.306 194.031 86.6594 237.495C76.3515 259.194 64.0694 274.08 50.0659 283.344C36.0834 292.593 20.2343 296.337 2.59449 295.502L2.40551 299.498Z",
    fill: "#FF671F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow3.7e63364a31fd4d943a9bc80692676110.svg";